export default (state={}, action) => {
    switch(action.type)
    {
        case 'SET_STATE_CHECK_EST':
            return action.payload;
        default: return state;
    }
}